import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import HeaderToolbar from './HeaderToolbar';

const Layout = () => {
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="bg-white text-gray-800 min-h-screen font-sans">
            {/* Header */}
            <HeaderToolbar
                scrollY={scrollY}
                isLoginOpen={isLoginOpen}
                setIsLoginOpen={setIsLoginOpen}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />

            {/* Main content */}
            <main >
                <Outlet />
            </main>

            {/* Footer */}
            {/* <Footer /> */}
        </div>
    );
};

export default Layout;
